(() => {
  const theme = window.theme || {};

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  function lock(on) {
    document.body.classList.toggle("is-locked", on);
  }

  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    lock(true);
  }

  function closeDrawer(el) {
    if (!el) return;
    el.hidden = true;
    const cart = qs("[data-cart-drawer]");
    if (cart?.hidden ?? true) lock(false);
  }

  async function sections(names) {
    const url = `/?sections=${names.join(",")}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("sections");
    return res.json();
  }

  function replaceSection(id, html) {
    const current = qs(`[id="shopify-section-${id}"]`);
    if (!current || !html) return;
    const wrap = document.createElement("div");
    wrap.innerHTML = html.trim();
    const next = wrap.firstElementChild;
    if (next) current.replaceWith(next);
  }

  async function refreshCart({ open } = {}) {
    const data = await sections(["cart-drawer", "header"]);
    const wasOpen = open || !qs("[data-cart-drawer]")?.hidden;
    replaceSection("cart-drawer", data["cart-drawer"]);
    replaceSection("header", data.header);
    if (wasOpen) openDrawer(qs("[data-cart-drawer]"));
  }

  function cartEndpoint(route, fallback) {
    const base = (route || fallback).replace(/\.js$/, "");
    return `${base}.js`;
  }

  let adding = false;

  async function add(id, quantity = 1) {
    if (adding) return;
    adding = true;
    try {
      const res = await fetch(cartEndpoint(theme.routes?.cartAdd, "/cart/add"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(id), quantity }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || theme.strings?.cartError || "Error");
      }
      if (document.body.classList.contains("template-cart")) {
        window.location.reload();
        return;
      }
      await refreshCart({ open: true });
    } finally {
      adding = false;
    }
  }

  async function change(key, quantity) {
    const res = await fetch(cartEndpoint(theme.routes?.cartChange, "/cart/change"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error(theme.strings?.cartError || "Error");
    if (document.body.classList.contains("template-cart")) {
      window.location.reload();
      return;
    }
    await refreshCart({ open: !qs("[data-cart-drawer]")?.hidden });
  }

  function selectVariant(root, id) {
    const select = qs("[data-variant-select]", root);
    if (!select) return;
    select.value = String(id);
    qsa("[data-select-variant]", root).forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.selectVariant === String(id));
    });
    const option = select.selectedOptions[0];
    const addBtn = qs("[data-add]", root);
    const price = qs("[data-price]", root);
    if (option && price) {
      const compareRaw = Number(option.dataset.compareRaw || 0);
      const priceRaw = Number(option.dataset.priceRaw || 0);
      price.innerHTML =
        compareRaw > priceRaw
          ? `<s class="price__compare">${option.dataset.compare}</s><span class="price__current">${option.dataset.price}</span>`
          : `<span class="price__current">${option.dataset.price}</span>`;
    }
    if (addBtn && option) {
      const available = option.dataset.available === "true";
      addBtn.disabled = !available;
      addBtn.textContent = available
        ? theme.strings?.addToBag || "Add to bag"
        : theme.strings?.soldOut || "Sold out";
    }
  }

  async function loadRelated() {
    const el = qs("[data-related]");
    if (!el?.dataset.url) return;
    try {
      const res = await fetch(el.dataset.url);
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const next = doc.querySelector("[data-related]");
      if (next) el.replaceWith(next);
    } catch {
      /* keep fallback grid */
    }
  }

  document.addEventListener("click", async (event) => {
    const t = event.target;
    if (!(t instanceof Element)) return;

    if (t.closest("[data-open-cart]")) {
      openDrawer(qs("[data-cart-drawer]"));
      return;
    }
    if (t.closest("[data-close-cart]")) {
      closeDrawer(qs("[data-cart-drawer]"));
      return;
    }

    const quick = t.closest("[data-quick-add]");
    if (quick instanceof HTMLButtonElement && !quick.disabled) {
      event.preventDefault();
      try {
        await add(quick.dataset.id);
      } catch (err) {
        window.alert(err.message);
      }
      return;
    }

    const remove = t.closest("[data-remove-item]");
    if (remove instanceof HTMLElement && remove.dataset.key) {
      event.preventDefault();
      try {
        await change(remove.dataset.key, 0);
      } catch (err) {
        window.alert(err.message);
      }
      return;
    }

    const qty = t.closest("[data-qty-change]");
    if (qty instanceof HTMLElement && qty.dataset.key) {
      event.preventDefault();
      const row = qty.closest("[data-qty]");
      const current = Number(row?.querySelector(".qty__value")?.textContent || 1);
      const next = current + Number(qty.dataset.qtyChange);
      try {
        await change(qty.dataset.key, Math.max(0, next));
      } catch (err) {
        window.alert(err.message);
      }
      return;
    }

    const variantBtn = t.closest("[data-select-variant]");
    if (variantBtn instanceof HTMLElement) {
      event.preventDefault();
      const root = variantBtn.closest("[data-product-form]");
      if (root) selectVariant(root, variantBtn.dataset.selectVariant);
      return;
    }

    const guide = t.closest("[data-toggle-guide]");
    if (guide) {
      event.preventDefault();
      const box = qs("[data-size-guide]", guide.closest("[data-product-form]") || document);
      if (box) box.hidden = !box.hidden;
      return;
    }

    const thumb = t.closest("[data-gallery-thumb]");
    if (thumb instanceof HTMLElement && thumb.dataset.src) {
      event.preventDefault();
      const gallery = thumb.closest("[data-gallery]");
      const main = qs("[data-gallery-main]", gallery || document);
      if (main instanceof HTMLImageElement) main.src = thumb.dataset.src;
      qsa("[data-gallery-thumb]", gallery || document).forEach((el) => {
        el.classList.toggle("is-active", el === thumb);
      });
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeDrawer(qs("[data-cart-drawer]"));
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.getAttribute("action")?.includes("/cart/add")) return;
    event.preventDefault();
    const select = qs("[data-variant-select]", form);
    const named = form.querySelector('[name="id"]');
    const id =
      select instanceof HTMLSelectElement
        ? select.value
        : named instanceof HTMLInputElement || named instanceof HTMLSelectElement
          ? named.value
          : "";
    if (!id) return;
    try {
      await add(id);
    } catch (err) {
      window.alert(err.message);
    }
  });

  loadRelated();
})();
